import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-performance-custom-brand',
  imports: [PeopleflowFooterComponent, HeaderLatestComponent],
  templateUrl: './performance-custom-brand.html',
  styleUrl: './performance-custom-brand.scss',
})
export class PerformanceCustomBrand {

}
